import { readCookie } from "utils/cookie";
import { REMEBER_KEY } from "config/cookies";

export default function getRememberedUser() {
  return JSON.parse(readCookie(REMEBER_KEY) || "null");
}
